export default function BoutonAppelVideo({ onClick, actif = false, disabled = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={disabled ? 'Indisponible' : 'Lancer un appel vidéo'}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        borderRadius: 20,
        border: 'none',
        background: actif ? '#5a1212' : disabled ? '#e8d5d0' : '#8b1a2a',
        color: disabled ? '#9a8080' : '#fff',
        fontSize: 12,
        fontWeight: 700,
        cursor: disabled ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap'
      }}
    >
      <span style={{ fontSize: 14, lineHeight: 1 }}>🎥</span>
      <span>{actif ? 'Appel en cours' : 'Appel vidéo'}</span>
    </button>
  );
}
